import { render, staticRenderFns } from "./FooterContacts.vue?vue&type=template&id=10569985&"
import script from "./FooterContacts.vue?vue&type=script&lang=js&"
export * from "./FooterContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports